export default {"src":"/_next/static/media/BoneJointInfections.70bd76e4.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};